module.exports = __webpack_public_path__ + "static/img/bg-fr.ef7d3fa8.png";